<template>
  <v-row>
    <template v-if="data.type_postulations_id==null">
      <v-col cols="12">
        <v-sheet
          width="100%"
          outlined
          height="40vh"
        >
          <v-row
            class="fill-height pa-8"
            align="center"
            justify="center"
          >
            <v-col cols="12" class="text-center">
              <h3 class="font-weight-regular text-uppercase">
                El equipo aún no comenzó con la carga de datos.
              </h3>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </template>

    <template v-if="data.type_postulations_id==1 || data.type_postulations_id==2">
      <v-col cols="12">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">

            <v-col cols="12" xl="6" md="6" sm="12">
              <p class="font-weight-regular text-uppercase">
                Convocatoria enviada por:
              </p>
              

              <p class="font-weight-light" v-if="data.user">
                {{ data.user.name + ' ' + data.user.lastname  }}
              </p>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <p class="font-weight-regular text-uppercase">
                Correo electrónico
              </p>
              
              <p class="font-weight-light"  v-if="data.user">
                {{ data.user.email }}
              </p>
            </v-col>

          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Tipo de postulación
              </p>
              
              <p class="font-weight-light">
                {{ (data.type_postulations!=null)?data.type_postulations.name:'--' }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Vertical de trabajo:
              </p>
              
              <p class="font-weight-light">
                {{ (data.vertical_works!=null)?data.vertical_works.name:'--' }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Grado de desarrollo actual:
              </p>
              
              <p class="font-weight-light">
                {{ (data.development_degree_ip!=null)?data.development_degree_ip.name:'--' }}
              </p>
            </v-col>

          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2" v-if="data.type_postulations_id==2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">

            <v-col cols="12">
              <p class="font-weight-regular text-uppercase">
                Nombre escuela:
              </p>
              
              <p class="font-weight-light">
                {{ data.name_school  }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Dirección<small><small>(escuela)</small></small>:
              </p>
              
              <p class="font-weight-light">
                {{ data.address_school  }}
              </p>
            </v-col>
            
            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Teléfono<small><small>(escuela)</small></small>:
              </p>
              
              <p class="font-weight-light">
                {{ data.phone_number_school  }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Correo eletrónico<small><small>(escuela)</small></small>:
              </p>
              
              <p class="font-weight-light">
                {{ data.email_school  }}
              </p>
            </v-col>
  
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2" v-if="data.type_postulations_id==2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">

            <v-col cols="12" xl="6" md="6" sm="12">
              <p class="font-weight-regular text-uppercase">
                Docente responsable:
              </p>

              <p class="font-weight-light">
                {{ (data.surname_teacher?.toUpperCase() || '') + ', ' + (data.name_teacher || '') }}
              </p>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <p class="font-weight-regular text-uppercase">
                DNI/Cedula/Pasaporte<small><small>(docente)</small></small>:
              </p>
              
              <p class="font-weight-light">
                {{ data.dni_teacher  }}
              </p>
            </v-col>
            
            <v-col cols="12" xl="6" md="6" sm="12">
              <p class="font-weight-regular text-uppercase">
                Teléfono<small><small>(docente)</small></small>:
              </p>
              
              <p class="font-weight-light">
                {{ data.phone_teacher  }}
              </p>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <p class="font-weight-regular text-uppercase">
                Correo eletrónico<small><small>(docente)</small></small>:
              </p>
              
              <p class="font-weight-light">
                {{ data.email_teacher  }}
              </p>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <p class="font-weight-regular text-uppercase">
                Fecha de nacimiento<small><small>(docente)</small></small>:
              </p>
              
              <p class="font-weight-light">
                {{ data.birthdate_teacher  }}
              </p>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <p class="font-weight-regular text-uppercase">
                Genero<small><small>(docente)</small></small>:
              </p>
              
              <p class="font-weight-light">
                {{ data.teacher_gender ? data.teacher_gender.name : '' }}
              </p>
            </v-col>

            <v-col cols="12" xl="6" md="6" sm="12">
              <p class="font-weight-regular text-uppercase">
                Materia<small><small>(docente)</small></small>:
              </p>
              
              <p class="font-weight-light">
                {{ data.subject_teacher  }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                País:
              </p>
              <p class="font-weight-light">
                {{ data.country?.name ? data.country.name : '--' }}
              </p>
            </v-col>

            <template v-if="(data.country?.name || '').toLowerCase() === 'argentina'">
              <v-col cols="12" xl="4" md="4" sm="12">
                <p class="font-weight-regular text-uppercase">
                  Provincia:
                </p>
                <p class="font-weight-light">
                  {{ data.provincia?.name ? data.provincia.name : '--' }}
                </p>
              </v-col>

              <v-col cols="12" xl="4" md="4" sm="12">
                <p class="font-weight-regular text-uppercase">
                  Localidad:
                </p>
                <p class="font-weight-light">
                  {{ data.localidad?.name ? data.localidad.name : '--' }}
                </p>
              </v-col>
            </template>

            <template v-if="(data.country?.name || '').toLowerCase() != 'argentina'">
              <v-col cols="12" xl="4" md="4" sm="12">
                <p class="font-weight-regular text-uppercase">
                  Provincia:
                </p>
                
                <p class="font-weight-light">
                  {{ data.other_provincia  }}
                </p>
              </v-col>

              <v-col cols="12" xl="4" md="4" sm="12">
                <p class="font-weight-regular text-uppercase">
                  Localidad:
                </p>
                
                <p class="font-weight-light">
                  {{ data.other_localidad }}
                </p>
              </v-col>
            </template>
  
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Título:
              </label>
            </v-col>
            <v-col cols="12">
              <label class="font-weight-light">
                {{ data.title }}
              </label>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Resumen:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.description }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Cantidad de integrantes del equipo:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.team_members_count }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Equipo:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.team }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Beneficiarios/clientes/usuarios:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.beneficiary_clients_users }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Problema:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.problem }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Solución:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.solution }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Innovación/Valor Agregado:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.innovation }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Plan de acción:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.action_plan }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2" v-if="data.curriculum_idea.length>0">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Antecedentes:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text" v-for="cv in data.curriculum_idea" :key="cv.id">
                <b>- {{ cv.type }}:</b><br>
                {{ cv.description }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2" v-if="data.images.length>0">
        <v-sheet
          width="100%"
          outlined>
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Imagenes:
              </label>
            </v-col>

            <v-col
              cols="12" 
              xl="4" 
              md="4" 
              sm="12" 
              v-for="item in data.images"
              v-bind:key="item.id">
              <v-card max-width="380px">
                <v-img
                  contain
                  :src="fullImageUrl(item.image_path)"
                  class="grey lighten-2"
                  height="220px"
                ></v-img>
              </v-card>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
      
    </template>

    <template v-if="data.type_postulations_id==3">
      <v-col cols="12">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Convocatoria enviada por:
              </p>
              
              <p class="font-weight-light" v-if="data.user">
                {{ data.user.name + ' ' + data.user.lastname  }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Correo electrónico
              </p>
              
              <p class="font-weight-light" v-if="data.user">
                {{ data.user.email }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Tipo de postulación
              </p>
              
              <p class="font-weight-light">
                {{ (data.type_postulations!=null)?data.type_postulations.name:'--' }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Vertical de trabajo:
              </p>
              
              <p class="font-weight-light">
                {{ (data.vertical_works!=null)?data.vertical_works.name:'--' }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Grado de desarrollo actual:
              </p>
              
              <p class="font-weight-light">
                {{ (data.development_degree_mdn!=null)?data.development_degree_mdn.name:'--' }}
              </p>
            </v-col>

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                Estadio de la Idea:
              </p>
              
              <p class="font-weight-light">
                {{ (data.entrepreneurship_stadia!=null)?data.entrepreneurship_stadia.name:'--' }}
              </p>
            </v-col>

          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">

            <v-col cols="12" xl="4" md="4" sm="12">
              <p class="font-weight-regular text-uppercase">
                País:
              </p>
              <p class="font-weight-light">
                {{ data.country?.name ? data.country.name : '--' }}
              </p>
            </v-col>

            <template v-if="(data.country?.name || '').toLowerCase() === 'argentina'">
              <v-col cols="12" xl="4" md="4" sm="12">
                <p class="font-weight-regular text-uppercase">
                  Provincia:
                </p>
                <p class="font-weight-light">
                  {{ data.provincia?.name ? data.provincia.name : '--' }}
                </p>
              </v-col>

              <v-col cols="12" xl="4" md="4" sm="12">
                <p class="font-weight-regular text-uppercase">
                  Localidad:
                </p>
                <p class="font-weight-light">
                  {{ data.localidad?.name ? data.localidad.name : '--' }}
                </p>
              </v-col>
            </template>

            <template v-if="(data.country?.name || '').toLowerCase() !== 'argentina'">
              <v-col cols="12" xl="4" md="4" sm="12">
                <p class="font-weight-regular text-uppercase">
                  Provincia:
                </p>
                
                <p class="font-weight-light">
                  {{ data.other_provincia  }}
                </p>
              </v-col>

              <v-col cols="12" xl="4" md="4" sm="12">
                <p class="font-weight-regular text-uppercase">
                  Localidad:
                </p>
                
                <p class="font-weight-light">
                  {{ data.other_localidad }}
                </p>
              </v-col>
            </template>
  
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Título:
              </label>
            </v-col>
            <v-col cols="12">
              <label class="font-weight-light">
                {{ data.title }}
              </label>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Resumen:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.description }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Cantidad de integrantes del equipo:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.team_members_count }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Equipo:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.team }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Problema:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.problem }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Solución:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.solution }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Mercado y segmentos de clientes:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.market }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Propuesta de valor:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.value_proposal }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Canales y relación con clientes:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.channels_with_customers }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Modelo de ingresos:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.revenue_model }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Actividades y recursos claves:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.activities_resources }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Inversión y Estructura de costos:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.investment_cost }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Competencia y soluciones alternativas existentes:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.competence }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Impacto esperado:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text">
                {{ data.expected_impact }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2" v-if="data.curriculum_idea.length>0">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Antecedentes:
              </label>
            </v-col>
            <v-col cols="12">
              <p class="font-weight-light text" v-for="cv in data.curriculum_idea" :key="cv.id">
                <b>- {{ cv.type }}:</b><br>
                {{ cv.description }}
              </p>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>

      <v-col cols="12" class="pt-2" v-if="data.images.length>0">
        <v-sheet
          width="100%"
          outlined 
        >
          <v-row class="pa-8">
            <v-col cols="12">
              <label class="font-weight-regular text-uppercase">
                Imagenes:
              </label>
            </v-col>

            <v-col 
              cols="12" 
              xl="4" 
              md="4" 
              sm="12" 
              v-for="item in data.images"
              v-bind:key="item.id">
              <v-card max-width="380px">
                <v-img
                  contain
                  :src="fullImageUrl(item.image_path)"
                  class="grey lighten-2"
                  height="220px"
                ></v-img>
              </v-card>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </template>
    
  </v-row>
</template>
<script>
  const APP_URL = process.env.VUE_APP_URL
  
  export default {
    props: ['data'],

    methods: {
      fullImageUrl(url) {
        return `${APP_URL}${url}`;
      }
    }
  };
</script>

